import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { removeStrategyStyleFilter } from '../../../../actions/actions'

export default function StrategyStylesFilters () {
  const strategyStyleFilters = useSelector(({ certFilters }) => certFilters.strategyStyles, shallowEqual)
  const dispatch = useDispatch()

  const onRemoveStrategyStyleClick = (strategyStyleId) => {
    dispatch(removeStrategyStyleFilter(strategyStyleId))
  }
  return (
    <div className='col-md-2'>
      {strategyStyleFilters.map((item, i) => {
        return (
          <span key={i} className='badge badge-pill badge-light' style={{ cursor: 'pointer' }} onClick={(e) => onRemoveStrategyStyleClick(item.id)}>{item.name}
            <i key={i} className='mdi mdi-cancel' />
          </span>
        )
      })}
    </div>
  )
}
